import React from 'react';
import { useState } from 'react';
import classes from './Cookie.module.css';

const Cookie = () => {
  const [show, setShow] = useState(true);

  const CHALLENGEDURATIONDAYS = 30;

  const setCookie = (path: string) => {
    const date = new Date();
    date.setDate(date.getDate() + CHALLENGEDURATIONDAYS);
    const ts = date.toUTCString();
    return (document.cookie = `accepted_cookies=true; Expires=${ts}; Secure; Path=${path}`);
  };

  const handleSetCookie = () => {
    setCookie('/');
    setShow(false);
  };

  return (
    <>
      {show ? (
        <div className={classes.cookie_container}>
          <div className={classes.text_box}>
            <div className={classes.hinweis}>
              {' '}
              <p>
                <strong>Hinweis:</strong> Wir verwenden Cookies, um unsere Website und unsere Services zu optimieren.{' '}
                <a href='/impressum-datenschutz' target='_blank' className={classes.link}>
                  Mehr Informationen
                </a>
              </p>
            </div>
            <div className={classes.contactBtnWrapper} style={{ textAlign: 'center' }} onClick={() => handleSetCookie()}>
              <a className={classes.contactBtn} href='#'>
                <span>OKAY</span>
              </a>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default Cookie;
